import notifies from "../mixins/Notifies"
import { has } from "lodash"

var auto_saves = {
    mixins: [notifies],
    methods: {
        saveField (field, data, record) {
            if(!record || !has(record, "id")) return

            this.$store.dispatch("RECORD_SAVE", {
                entity: this.entity,
                id: record.id,
                data
            }).then(() => {
                this.$emit("saved", field, data)
            }).catch(error => {
                if(field !== null) this.has_error = error.topic_id && (error.topic_id === field)
                this.$error(error.message)
            })
        },
        changedValue (event, value, record) {
            this.has_error = false
            record = record || this.value

            if(value === undefined) value = event.target.value
            const field = event.target.name
            const data = { [field]: value }
            if(!this.emitOnly) this.saveField(field, data, record)
            // this.$emit('input', value)
            this.$emit("change", field, value, record[field])
        }
    },
    props: {
        entity: {
            type: String
            // required: true
        },
        name: {
            type: String
            // required: true
        },
        value: {
            default: null
        },
        emitOnly: {
            default: false
        },
        required: {
            default: false
        }
    },
    data () {
        return {
            has_error: false
        }
    }
}

export default auto_saves
